import { produce } from "immer";
import { theme } from "../../theme/theme";
import { LOAD_API_DATA, SET_API_DATA } from "./dataAssets.type";
const INITAL_STATE = {
    apiData: {
        newDataAssest: {
            loading: false,
            status: "idle",
            isError: false,
            errorMessage: "",
            data: []
        },
        dataAssestsDetails: {
            loading: false,
            status: "idle",
            data: [{ title: "Assets", value: "10", color: theme.colors.primary, infoText:'Total number of data assets available.' },
            { title: "Assets Executed", value: "0", color: theme.colors.primary, infoText:'Count of assets not meeting quality standards.' },
            { title: "Quality Rule", value: "27", color: theme.colors.primary, infoText:'Number of data quality (DQ) rules defined.' },
            { title: "Rules Executed", value: "56", color: theme.colors.primary, infoText:'Number of DQ rules successfully run.' },
            { title: "Rules Failed", value: "0", color: theme.colors.primary, infoText:'Number of DQ rules that failed during execution.' },
            { title: "Quality Score", value: "92.6%", color: theme.colors.success, infoText:'Overall percentage score indicating data quality across all assets.' }
            ],
            isError: false,
            errorMessage: ""
        },
        dataAssestsList: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dataProductList: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dataAssetCountryList: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        userDetails: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        }
    },
    formData: {
        
        dataAssetFormCountryList: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        }
    }

}

const dataAssetsReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
      
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default dataAssetsReducer;